import warehouseIcon from "@/assets/images/sklad.svg";
import productsIcon from "@/assets/images/tovars.svg";
import settingsIcon from "@/assets/images/integration2.svg";
import ordersIcon from "@/assets/images/orders.svg";

export type HeaderTitleInfoData = {
  title: string;
  imageSrc?: string;
  imageAlt?: string;
};

export type HeaderTitleMetaMap = Record<string, HeaderTitleInfoData>;

export const headerTitleMetaMap: HeaderTitleMetaMap = {
  addCategory: {
    title: "Добавить категорию",
    imageSrc: productsIcon,
    imageAlt: "Иконка: тележка с товаром",
  },
  addLabel: {
    title: "Новая этикетка",
    imageSrc: settingsIcon,
    imageAlt: "Иконка: шестерёнки",
  },
  editLabel: {
    title: "Редактирование этикетки",
    imageSrc: settingsIcon,
    imageAlt: "Иконка: шестерёнки",
  },
  addProduct: {
    title: "Создание товара",
    imageSrc: productsIcon,
    imageAlt: "Иконка: тележка с товаром",
  },
  addWarehouse: {
    title: "Создание склада",
    imageSrc: warehouseIcon,
    imageAlt: "Иконка: склад",
  },
  categories: {
    title: "Категории",
    imageSrc: productsIcon,
    imageAlt: "Иконка: тележка с товаром",
  },
  editCategory: {
    title: "Редактирование категории",
    imageSrc: productsIcon,
    imageAlt: "Иконка: тележка с товаром",
  },
  editProduct: {
    title: "Редактор товара",
    imageSrc: productsIcon,
    imageAlt: "Иконка: тележка с товаром",
  },
  editWarehouse: {
    title: "Редактирование склада",
    imageSrc: warehouseIcon,
    imageAlt: "Иконка: склад",
  },
  integrations: {
    title: "Настройка интеграций",
    imageSrc: settingsIcon,
    imageAlt: "Иконка: шестерёнки",
  },
  labels: {
    title: "Этикетки",
    imageSrc: settingsIcon,
    imageAlt: "Иконка: шестерёнки",
  },
  organizations: {
    title: "Организации",
    imageSrc: settingsIcon,
    imageAlt: "Иконка: шестерёнки",
  },
  products: {
    title: "Товары",
    imageSrc: productsIcon,
    imageAlt: "Иконка: тележка с товаром",
  },
  remains: {
    title: "Остатки",
    imageSrc: warehouseIcon,
    imageAlt: "Иконка: склад",
  },
  staff: {
    title: "Сотрудники",
    imageSrc: settingsIcon,
    imageAlt: "Иконка: шестерёнки",
  },
  staffAccess: {
    title: "Настройка доступа",
    imageSrc: settingsIcon,
    imageAlt: "Иконка: шестерёнки",
  },
  staffAdd: {
    title: "Добавление сотрудника",
    imageSrc: settingsIcon,
    imageAlt: "Иконка: шестерёнки",
  },
  warehouses: {
    title: "Склады",
    imageSrc: warehouseIcon,
    imageAlt: "Иконка: склад",
  },
  partnerLogs: {
    title: "Логи",
    imageSrc: settingsIcon,
    imageAlt: "Иконка: шестерёнки",
  },
  fbsOrders: {
    title: "Заказы",
    imageSrc: ordersIcon,
    imageAlt: "Иконка: Корзина",
  },
  orderSingle: {
    title: "Заказ",
    imageSrc: ordersIcon,
    imageAlt: "Иконка: Корзина",
  },
  supplies: {
    title: "Поставки",
    imageSrc: ordersIcon,
    imageAlt: "Иконка: Корзина",
  },
  suppliesSingle: {
    title: "Поставка",
    imageSrc: ordersIcon,
    imageAlt: "Иконка: Корзина",
  },
  boxes: {
    title: "Короба WB",
    imageSrc: ordersIcon,
    imageAlt: "Иконка: Корзина",
  },
  boxesSingle: {
    title: "Короб WB",
    imageSrc: ordersIcon,
    imageAlt: "Иконка: Корзина",
  },
  combineProducts: {
    title: "Объединение товаров",
    imageSrc: productsIcon,
    imageAlt: "Иконка: тележка с товаром",
  },
};
